<template>
  <common-modal ref="confirm_delete_modal" v-model:active="isActive" size="max-w-sm md:max-w-lg">
    <template v-if="titleText" #header>
      <div class="flex justify-center items-center py-6 relative border-b border-gray-200">
        <h2 class="text-xl text-color-base font-bold">{{ titleText }}</h2>
        <button class="modal-close cursor-pointer z-50 absolute" @click="closeModal">
          <img src="/images/common/icon-modal-close.svg" />
        </button>
      </div>
    </template>

    <!-- アカウント名 -->
    <div class="my-4">
      <div class="my-4">
        <require-label :content="$t('organization.create_member_modal.name')" :is-required="true"></require-label>
        <div class="my-2 flex justify-between items-center">
          <input-text
            v-model:value="name"
            :placeholder="$t('organization.create_member_modal.placeholder.name')"
          ></input-text>
        </div>
      </div>
      <!-- メールアドレス -->
      <div class="my-4">
        <require-label :content="$t('organization.create_member_modal.email')" :is-required="true"></require-label>
        <div class="my-2 flex justify-between items-center">
          <input-text
            v-model:value="email"
            :disabled="true"
            :placeholder="$t('organization.create_member_modal.placeholder.email')"
          ></input-text>
        </div>
      </div>
      <!-- 現在のパスワード -->
      <div class="my-4">
        <require-label
          :content="$t('common.header.edit_modal.form.current_password')"
          :is-required="true"
        ></require-label>
        <div class="my-2">
          <input-password
            v-model:value="currentPassword"
            :placeholder="$t('organization.create_member_modal.placeholder.email')"
          ></input-password>
        </div>
      </div>
      <!-- 新しいパスワード -->
      <div class="my-4">
        <require-label :content="$t('common.header.edit_modal.form.new_password')" :is-required="false"></require-label>
        <div class="my-2">
          <input-password
            v-model:value="newPassword"
            :placeholder="$t('organization.create_member_modal.placeholder.email')"
          ></input-password>
        </div>
      </div>
      <!-- 新しいパスワード（確認） -->
      <div class="my-4">
        <require-label
          :content="$t('common.header.edit_modal.form.confirm_new_password')"
          :is-required="false"
        ></require-label>
        <div class="my-2">
          <input-password
            v-model:value="confirmNewPassword"
            :placeholder="$t('organization.create_member_modal.placeholder.email')"
          ></input-password>
        </div>
      </div>
    </div>
    <div v-if="errors">
      <ul>
        <li v-for="(error, index) in errors" :key="index" class="text-red-500 text-xs">
          {{ error }}
        </li>
      </ul>
    </div>

    <template #footer>
      <div class="flex justify-center border-t border-gray-200 py-4 gap-4">
        <button-common width="sm" variant="cancel" @click="onCancelHandler">
          {{ $t('common.modal.cancel') }}
        </button-common>
        <button-common width="sm" variant="submit" @click="confirmUpdate">
          {{ $t('common.modal.update') }}</button-common
        >
      </div>
    </template>
  </common-modal>
</template>

<script>
import CommonModal from '@/member/components/modals/CommonModal'
import { modalMixin } from '@/member/mixins/modalMixin'
import ButtonCommon from '@/common/components/molecules/ButtonCommon'
import InputText from '@/common/components/atoms/InputText'
import RequireLabel from '@/common/components/molecules/RequireLabel'
import InputPassword from '@/common/components/molecules/InputPassword'

export default {
  name: 'EditMemberModal',
  components: { ButtonCommon, CommonModal, InputText, RequireLabel, InputPassword },
  mixins: [modalMixin],
  props: {
    confirmClass: {
      type: String,
      default: 'text-center',
    },
    title: {
      type: String,
      default: '',
    },
    variantCancel: {
      type: String,
      default: 'white',
    },
    typeCancel: {
      type: String,
      default: 'normal',
    },
    isDisplayCloseIcon: {
      type: Boolean,
      default: true,
    },
    variantSubmit: {
      type: String,
      default: 'green',
    },
    submitTitle: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      isActive: this.active,
      name: '',
      email: '',
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    }
  },
  computed: {
    titleText() {
      return this.title ?? this.$t('common.modal.title.confirm_delete')
    },
    submitText() {
      return this.submitTitle || this.$t('modal.confirm_delete.btn_submit')
    },
  },
  watch: {
    isActive(newValue) {
      this.$emit('input')
      this.$emit('update:active', newValue)
    },
  },
  methods: {
    onOpenModal({ memberInfo }) {
      this.name = memberInfo.name
      this.email = memberInfo.email
      this.openModal()
    },
    confirmUpdate() {
      this.$emit('update', {
        name: this.name,
        email: this.email,
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
        confirmNewPassword: this.confirmNewPassword,
      })
    },
    onCancelHandler() {
      this.$emit('cancel')
      this.closeModal()
    },
  },
}
</script>

<style scoped>
.text-color-base {
  color: #222222;
}
.modal-close {
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
